import { Stack } from 'component-library';
import { useTranslation } from 'react-i18next';

import { R1FactType } from '@/api/rest/resources/types/fact';
import { CanopyCoverHistoricalChart } from '@/components/Charts';
import { ChartHeading } from '@/components/Charts/components/ChartHeading';
import { GraphFact } from '@/components/Charts/types';
import { GraphTileProps } from '@/components/IndicatorCard/GraphTile';
import { useOrganizationIndicatorGraphFact } from '@/pages/shared/hooks/useOrganizationFact';

import { NoData } from '../../../../components/NoData';

export const CanopyCoverGraphTile = ({ zoom, setZoom, plotGroupId }: Partial<GraphTileProps>) => {
  const { t } = useTranslation();

  const canopyCoverHistoricFact = R1FactType.r1_soil_carbon_historic_total_graph;
  const { [canopyCoverHistoricFact]: canopyCoverHistoric } = useOrganizationIndicatorGraphFact<GraphFact[]>(
    canopyCoverHistoricFact,
    null,
    undefined,
    plotGroupId,
  ); // TODO: MVP-4772 - change with forest fact
  const chartData = canopyCoverHistoric?.value;

  const noChartData = !chartData?.length;
  if (noChartData) {
    return <NoData />;
  }

  return (
    <Stack center data-testid='canopy-cover-graph-tile'>
      <Stack spacing={2.5} className='w-full items-center justify-center px-1 py-6 lg:items-start lg:p-8 lg:pl-1'>
        <ChartHeading
          heading={t('shared.ncaDetail.details.forest.labels.historicalCanopyCoverGraphHeadline')}
          popover={{
            title: t('shared.ncaDetail.details.forest.explainers.historicalCanopyCover.title'),
            body: t('shared.ncaDetail.details.forest.explainers.historicalCanopyCover.body'),
          }}
          className='w-full px-6 sm:px-0'
        />
        <CanopyCoverHistoricalChart
          data={chartData}
          showTooltip={true}
          data-testid='canopy-cover-historic-chart'
          zoom={zoom}
          setZoom={setZoom}
        />
      </Stack>
    </Stack>
  );
};
